/**
 *
 * POS Table Details
 * point of sales table information
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

// Consts and Libs

// Components
import Loading from '../../../components/general/Loading';
import Error from '../../../components/general/Error';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPen} from '@fortawesome/free-solid-svg-icons';
import AppAPI from '../../../lib/api';

// Actions
import * as POSActions from '../../../redux/pos/actions';
import PageHeader from '../../../components/dashboard/PageHeader';

/* Redux ==================================================================== */
// What data from the store shall we send to the component?
const mapStateToProps = (state) => ({
  property: state.property.property,
  pos: state.pos.pos,
  table: state.pos.table,
});

// Any actions to map to the component?
const mapDispatchToProps = {
  setPOSTable: POSActions.setPOSTable,
};

/* Component ==================================================================== */
class POSTableDetails extends Component {
  static componentName = 'POSTableDetails';

  static propTypes = {
    match: PropTypes.object.isRequired,
  };

  componentDidMount = () => {
    this.fetchInitData();
  };

  fetchInitData = () => {
    if (this.props.match.params.POSTableId) {
      this.props.setPOSTable(this.props.match.params.POSTableId, this.props.match.params.POSId)
        .then(() => {
          this.setState({
            loading: false,
          });
        })
        .catch((err) => {
          const error = AppAPI.handleError(err);
          this.setState({
            loading: false,
            error,
          });
        });
    } else {
      this.setState({
        loading: false,
        error: true,
      });
    }
  }


  render = () => {

    const {loading, error} = this.state;
    const {pos, table} = this.props;

    if (loading) return <Loading/>;
    if (error) return <Error full={true} text={error}/>;

    return (
      <div className="pos-table-details screen-container ">
        <Helmet>
          <title>Point of Sales | Table</title>
        </Helmet>

        <PageHeader
          subHeader={true} history={this.props.history} title={'Table Details'}
          description={`Settings & Configuration for table : ${table.name}`}
        />

        <div className={'row'}>
          <div className={'col-lg-9 col-md-9 col-sm-12'}>
            <div className={'row'}>
              <div className={'col-12 col-md-6 mb-3'}>
                <ul className="list-group">
                  <li className="list-group-item">
                    <strong>Reference</strong> : {table.ref_no}
                  </li>
                </ul>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-12 col-md-6 mb-3'}>
                <ul className="list-group">
                  <li className="list-group-item"><strong>Name</strong> : {table.name}</li>
                  <li className="list-group-item"><strong>Occupancy</strong> : {table.occupancy} Pax</li>
                  <li className="list-group-item"><strong>Table Geometry</strong> : {table.table_shape_display}</li>
                </ul>
              </div>
              <div className={'col-12 col-md-6 mb-3'}>
                <ul className="list-group">
                  <li className="list-group-item">
                    <strong>Service Status</strong> :
                    <span className={'badge ' + (table.service_status === 1 ? 'badge-success' : 'badge-danger')}>
                      {table.service_status_display}
                    </span>
                  </li>
                  <li className="list-group-item"><span className="glyphicon glyphicon-user"/>
                    <strong>Availability Status</strong> : <span
                      className={'badge ' + (table.availability_status === -1 ? 'badge-danger' : table.availability_status === 1 ? 'badge-success' : 'badge-info')}>
                      {table.availability_status_display}</span>
                  </li>
                  <li className="list-group-item">
                    <strong>Operation Status</strong> :
                    <span className={'badge ' + (table.maintenance_status === 1 ? 'badge-success' : 'badge-danger')}>
                      {table.maintenance_status_display}
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className={'row'}>
              <div className={'col-12 col-md-12 mb-3'}>
                <ul className="list-group">
                  <li className="list-group-item">
                    <strong>Short Description</strong> : {table.table_note || 'N.A'}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12">
            <ul className="list-group">
              <li className="list-group-item">
                <Link
                  to={`/settings/pos/${pos.hash}/table/${table.hash}/edit`}
                  className={'btn btn-link p-0'}>
                  <FontAwesomeIcon icon={faPen} size={'sm'} className={'mr-2'}/> Edit
                </Link>
              </li>
            </ul>
          </div>
        </div>

      </div>
    );
  };


  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
    };
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(POSTableDetails);